import React from "react";
import { Link } from "@jsq/ds/core";
import { SupportingDocument, SupportingDocumentLinkProps } from "./types";

/**
 * Reusable cell renderer for displaying supporting document links in AG Grid tables.
 * Shows "View document" link with external icon when documents exist, empty when none.
 *
 * @param supportingDocuments - Array of supporting documents with id and viewUrl
 * @param className - Optional CSS class name
 */
export const SupportingDocumentLink: React.FC<SupportingDocumentLinkProps> = ({
  supportingDocuments,
  className,
}) => {
  // If no documents, show empty cell
  if (!supportingDocuments || supportingDocuments.length === 0) {
    return null;
  }

  // For now, show the first document. In the future, this could be enhanced
  // to show a count or dropdown for multiple documents
  const firstDocument = supportingDocuments[0];

  return (
    <Link
      href={firstDocument.viewUrl}
      variant="primary"
      shouldOpenInNewTab
      className={className}
    >
      View document
    </Link>
  );
};

export type { SupportingDocument, SupportingDocumentLinkProps };
export default SupportingDocumentLink;
